import { useGetBriefTotalAggregation } from "@entities/brief/lib/hooks/useGetBriefTotalAggregation";
import { BriefInvoice } from "@features/BriefInvoice/ui/BriefInvoice";
import { BriefLedger } from "@features/BriefLedger/ui/BriefLedger";
import { BriefPayment } from "@features/BriefPayment/ui/BriefPayment";
import { formatData } from "@shared/lib/utils/formatData";
import { Descriptions, Flex, Tabs } from "antd";
import { useParams } from "react-router-dom";

export function BriefFinance() {
  const { briefId } = useParams();
  const { aggregation } = useGetBriefTotalAggregation(briefId || "");

  const formatMoney = (money: number) => {
    return `₹${money.toFixed(2)}`;
  };

  return (
    <Flex vertical gap={16}>
      <Descriptions
        bordered
        title=" Total Overview"
        items={[
          {
            key: "1",
            label: "Ledger Total Amount",
            children: formatMoney(aggregation?.ledger.all?.totalAmount || 0),
          },
          {
            key: "4",
            label: "Invoice Total Amount",
            children: formatMoney(aggregation?.invoice.all.totalAmount || 0),
          },
          {
            key: "7",
            label: "Payments All Amount Received",
            children: formatMoney(
              aggregation?.payments.all.amountReceived || 0
            ),
          },
          {
            key: "2",
            label: "Ledger Debit Amount",
            children: formatMoney(aggregation?.ledger.debits.totalAmount || 0),
          },
          {
            key: "5",
            label: "Invoice Debit Amount",
            children: formatMoney(aggregation?.invoice.debits.totalAmount || 0),
          },

          {
            key: "8",
            label: "Payments Debit Amount Received ",
            children: formatMoney(
              aggregation?.payments.debits.amountReceived || 0
            ),
          },
          {
            key: "3",
            label: "Ledger Credit Amount",
            children: formatMoney(aggregation?.ledger.credits.totalAmount || 0),
          },
          {
            key: "6",
            label: "Invoice Credit Amount",
            children: formatMoney(
              aggregation?.invoice.credits.totalAmount || 0
            ),
          },
          {
            key: "9",
            label: "Payments Credit Amount Received",
            children: formatMoney(
              aggregation?.payments.credits.amountReceived || 0
            ),
          },
        ]}
      />
      <Tabs
        defaultActiveKey={"ledger"}
        items={[
          {
            key: "ledger",
            label: "Ledger",
            children: <BriefLedger briefId={briefId || ""} />,
          },
          {
            key: "invoice",
            label: "Invoice",
            children: <BriefInvoice briefId={briefId || ""} />,
          },
          {
            key: "paymanets",
            label: "Payments",
            children: <BriefPayment briefId={briefId || ""} />,
          },
        ]}
      />
    </Flex>
  );
}
